module.exports = __webpack_public_path__ + "static/media/correcoes-4.08558763.png";